// extracted by mini-css-extract-plugin
module.exports = {"loading":"ImageWithLoading_loading__2Cb6Y","pulse":"ImageWithLoading_pulse__1dyyZ"};